import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConsultaService {

  private url = environment.server + environment.app + environment.api;
  private urlValidacion = environment.server + environment.app + environment.api_identidad;

  constructor(private http: HttpClient) { }

  validacionIdentidad(cedulaIdentidad: any): Observable<any> {
    const url = `${this.urlValidacion}validacion`;
    return this.http.post(url, cedulaIdentidad)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  consultaCompensacion(): Observable<any> {
    const url = `${this.url}compensacion`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  validacionRestitucion(): Observable<any> {
    const url = `${this.url}validacion`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }

  consultaRestitucion(): Observable<any> {
    const url = `${this.url}consulta`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );

  }



  detallePlanPago(): Observable<any> {
    const url = `${this.url}detalle-plan-pago`;
    return this.http.get(url)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }

  envioCorreoCompensacion(email:any): Observable<any>{
    const url = `${this.url}autorizaciones/correo`;
    return this.http.post(url, email)
      .pipe(
        catchError(this.handleError) // Maneja el error
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente
      console.error('Ocurrió un error:', error.error.message);
    } else {
      // Error del lado del servidor
      console.error(
        `Código de estado del backend: ${error.status}, ` +
        `cuerpo: ${error.error}`);
    }
    // Retorna un observable con un mensaje de error para que el componente lo procese
    return throwError('Hubo un problema con la solicitud; por favor intenta nuevamente más tarde.');
  }


}
